import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/inquiryCode",
    name: "inquiryCode",
    component: dashboard,
    redirect: {
      name: "inquiryCodeIndex"
    },
    children: [
      {
        path: "inquiryCodeIndex",
        name: "inquiryCodeIndex",
        meta: { title: "已售产品捆绑统计" },
        component: () => import("@/views/inquiryCode/index.vue"),
        children: []
      }
    ]
  }
];
